import React from 'react'
import Login from './Login'

const index = () =><Login/>

export default index